import { render, staticRenderFns } from "./NsTabs.vue?vue&type=template&id=ca3cb4c2&"
import script from "./NsTabs.vue?vue&type=script&lang=js&"
export * from "./NsTabs.vue?vue&type=script&lang=js&"
import style0 from "./NsTabs.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports